export const SERVICE_CATEGORY_TYPE = {
  SERVICE: 0,
  POINT_OF_INTEREST: 1,
} as const;

export interface ServiceCategory {
  id: number | string;
  categoryType: number;
  name?: string;
  description?: string;
  customIcon?: string;
  defaultIcon?: string;
  position?: number;
  sort?: number;
}
